import axios from "axios"
import { apiGet, apiPost, getObject } from "../../utils"
import { API_URL } from "../../constants"

export function getAdminProfileAPI() {
    return apiGet('/api/getAdminProfileAdmin')
}

export function applyLeaveAPI(data) {
    return apiPost('/api/applyLeaveAdmin', data)
}

export function getLeaveCalendarAPI() {
    return apiGet('/api/getLeaveCalendarAdmin')
}

export function getUpcomingLeavesAPI() {
    return apiGet('/api/getUpcomingLeavesAdmin')
}

export function getMyLeavesAPI() {
    return apiGet('/api/getMyLeavesAdmin')
}

export function cancelLeaveAPI(data) {
    return apiPost('/api/cancelLeaveAdmin', data)
}

export function getBlockedDatesAPI() {
    return apiGet('/api/getBlockedDatesAdmin')
}

export function getPendingLeaveRequestsAPI() {
    return apiGet('/api/getPendingLeaveRequestsAdmin')
}

export function reviewLeaveAPI(data) {
    return apiPost('/api/reviewLeaveAdmin', data)
}

export function getLeaveHistoryAPI(data) {
    return apiGet('/api/getLeaveHistoryAdmin', data)
}

export function exportLeaveHistoryAPI(month) {
    const auth = getObject("auth") || {}
    return axios.get(`${API_URL}/api/exportLeaveHistoryAdmin?month=${month}`, {
        headers: { Authorization: auth },
        responseType: 'blob'
    })
}
